const INVALIDATING_MUTATIONS = new Set([
  'updateSlideActive',
  'updateSlideById',
  'setSlides',
  'addSlides',
])

const NON_INVALIDATING_SLIDE_KEYS = new Set([
  'id',
  'slideId',
  'version',
  'updatedAt',
  'lastModifiedAt',
  'isAIIndicatorVisible',
])

export const hasMeaningfulSlideChanges = (payload) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return true
  }

  return Object.keys(payload).some((key) => !NON_INVALIDATING_SLIDE_KEYS.has(key))
}

const readinessCheckerStalePlugin = (store) => {
  store.subscribe((mutation) => {
    if (!INVALIDATING_MUTATIONS.has(mutation.type)) return

    if (['updateSlideActive', 'updateSlideById'].includes(mutation.type)
      && !hasMeaningfulSlideChanges(mutation.payload)) {
      return
    }

    if (!store.getters['aiPotentialIssues/canInvalidateFreshResults']) return

    store.dispatch('aiPotentialIssues/markReadinessCheckAsStaleAction')
  })
}

export default readinessCheckerStalePlugin
